namespace RioERP.Masters {
    export interface WhatsAppMessagesRow {
        Id?: number;
        Wid?: number;
        CustomerId?: number;
        Type?: Web.Enums.WhatsMessageType;
        Status?: string;
        SentDate?: string;
        InsertDate?: string;
        InsertUserId?: number;
        IsActive?: number;
        ErrorMessage?: string;
    }

    export namespace WhatsAppMessagesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Wid';
        export const localTextPrefix = 'Masters.WhatsAppMessages';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Wid = "Wid",
            CustomerId = "CustomerId",
            Type = "Type",
            Status = "Status",
            SentDate = "SentDate",
            InsertDate = "InsertDate",
            InsertUserId = "InsertUserId",
            IsActive = "IsActive",
            ErrorMessage = "ErrorMessage"
        }
    }
}
